import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CountryStoreActions,
  CountryStoreSelectors,
  CountryStoreReducer,
} from './index';
import { CountryDto } from '@cradua/data';

@Injectable()
export class CountryFacade {
  constructor(private store: Store<CountryStoreReducer.CountryPartialState>) {}

  countryRecord$ = this.store.select(CountryStoreSelectors.getSelected);
  countryRecordError$ = this.store.select(
    CountryStoreSelectors.getCountryError
  );

  getselected() {
    return this.store.select(CountryStoreSelectors.getSelected);
  }

  get isLoadingCountry() {
    this.store.dispatch(CountryStoreActions.loadCountry());
    return this.store.select(CountryStoreSelectors.loadingCountry);
  }

  get loadCountry() {
    this.store.dispatch(CountryStoreActions.loadCountry());
    return this.store.select(CountryStoreSelectors.getAllCountry);
  }

  addCountry(newCountry: CountryDto[]) {
    this.store.dispatch(CountryStoreActions.addCountry({ newCountry }));
  }

  updateCountry(updateCountry: CountryDto[]) {
    this.store.dispatch(CountryStoreActions.updateCountry({ updateCountry }));
  }

  removeCountry(ids: string[]) {
    this.store.dispatch(CountryStoreActions.removeCountry({ ids }));
  }
}
